import React, { Component } from "react";
import {
    Icon,
    TextField,
    Text,
    Spinner,
    Collapsible,
    Thumbnail,
    Tooltip,

} from "@shopify/polaris";
import {
    SearchMajor,
    ChevronUpMinor,
    ChevronDownMinor,
    NoteMajor,

} from "@shopify/polaris-icons";
import { reqGetSelectDataList } from "../../api";
import "./index.css";


import Language from '../../i18n/Language';
import { cloneDeep, debounce } from "lodash";
const t = Language

class AddLinks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: this.props.mode,
            searchVal: '', // 搜索值
            typeArr: {
                "Products": { total: 0, list: [] },
                "Collections": { total: 0, list: [] },
                "Blogs": { total: 0, list: [] },
                "Other Pages": { total: 0, list: [] },
            },
            listLoading: true,
            typeSel: [], // 打开类型
            selectedArr: {
                "Products": [],
                "Homepage": [],
                "Collections": [],
                "Blogs": [],
                "Other Pages": [],
            },
            page: { product: 1, collection: 1, blog: 1, page: 1 },
            applyKeywordVal: this.props.applyKeywordVal,
            viewMoreLoading: [], // view more 
            homeKeywords: '', 
            isNotShowTitle: this.props.isNotShowTitle,
        };
    }

    componentDidMount() {
        // 获取列表
        let { page } = this.state;
        this.getSelectAllData('', '', page);
    }

    shouldComponentUpdate(nextProps) {
        if(nextProps.applyKeywordVal !== this.props.applyKeywordVal) {
            this.setState({
                applyKeywordVal: nextProps.applyKeywordVal,
            })
        }

        return true;
    }

    // 获取列表数据
    getSelectAllData = debounce(async (mode = 'get', types = '', pageAll) => {
        let { searchVal, applyKeywordVal } = this.state;
        if(!pageAll) {
            pageAll = { product: 1, collection: 1, blog: 1, page: 1 }
        }
        let params = {
            keyword: applyKeywordVal,
            type: types,
            title: searchVal,
            page: pageAll,
            size: { product: 10, collection: 10, blog: 10, page: 10 },
        }

        const res = await reqGetSelectDataList(params);
        if (res.ack === 1) {
            let lists = res.data;
            let typeAll = {
                "Products": "product",
                "Collections": "collection",
                "Blogs": "blog",
                "Other Pages": "page",
            }
            let listArr = cloneDeep(this.state.typeArr);
            Object.keys(listArr).forEach(item => {
                if(mode === 'search') {
                    listArr[item].total = lists[typeAll[item]].total;
                    listArr[item].list = lists[typeAll[item]].list;
                } else if(mode === 'more') {
                    if(types === typeAll[item]) {
                        listArr[item].total = lists[typeAll[item]].total;
                        listArr[item].list = listArr[item].list.concat(lists[typeAll[item]].list);
                    }
                } else {
                    listArr[item].total = lists[typeAll[item]].total;
                    listArr[item].list = listArr[item].list.concat(lists[typeAll[item]].list);
                }
            })
            this.setState({
                typeArr: listArr,
                homeKeywords: res.data.home,
                listLoading: false,
                viewMoreLoading: [],

            }, () => {
                if(mode === 'search' && searchVal !== '') {
                    // 搜索方式
                    let typeList = [];
                    Object.keys(listArr).forEach(i => {
                        if(i !== "Homepage" && listArr[i].list.length > 0) {
                            typeList.push(i);
                        }
                    })
                    this.setState({
                        typeSel: typeList,
                    })
                } else if(mode === 'more') {
                    // console.log(mode)
                } else {
                    let { selectedArr } = this.state;
                    let typeList = [];
                    Object.keys(selectedArr).forEach(i => {
                        if(i !== "Homepage" && selectedArr[i].length > 0) {
                            typeList.push(i);
                        }
                    })
                    this.setState({
                        typeSel: typeList,
                    })
                }
            })
        }
    }, 500)

    // 搜索
    handleSearchValue = (val) => {
        this.setState({
            searchVal: val,
            page: { product: 1, collection: 1, blog: 1, page: 1 }
        }, () => {
            this.getSelectAllData('search');
        })
    }

    // 打开下拉
    openSelectType = (types) => {
        let curType = cloneDeep(this.state.typeSel);
        if (types !== "Homepage") {
            if (curType.includes(types)) {
                curType.splice(curType.indexOf(types), 1);
            } else {
                curType.push(types)
            }
            this.setState({
                typeSel: curType
            })
        } else {
            // 直接选中
            this.selectProductItem("Homepage", { id: 1 });
        }
    }

    // 选中产品 
    selectProductItem = (obj, data) => {
        let { selectedArr } = this.state;
        let newList = cloneDeep(selectedArr);
        if (newList[obj].includes(data.id)) {
            newList[obj].splice(newList[obj].indexOf(data.id), 1);
        } else {
            newList[obj].push(data.id);
        }
        this.setState({
            selectedArr: newList
        }, () => {
            let { mode, homeKeywords, typeArr } = this.state;
            if(mode === "multiple") {
                this.props.changeSelectApply(newList, typeArr, homeKeywords);
            } else {
                this.props.changeSelectApply([obj, data]);
            }
        })
    }

    // 查询更多
    ViewMoreItem = (obj, data) => {
        let { page, viewMoreLoading } = this.state;
        let typeCompare = {
            "Products": "product",
            "Collections": "collection",
            "Blogs": "blog",
            "Other Pages": "page",
        }
        let curArray = cloneDeep(viewMoreLoading);
        let curPage = cloneDeep(page);
        curPage[typeCompare[obj]] = curPage[typeCompare[obj]] + 1;
        curArray.push(obj);
        this.setState({
            viewMoreLoading: curArray,
            page: curPage,
        }, () => {
            this.getSelectAllData('more', typeCompare[obj], curPage);
        })
    }

    render() {
        const {
            state: {
                searchVal,
                typeArr,
                listLoading,
                typeSel,
                selectedArr,
                viewMoreLoading,
                isNotShowTitle,

            }
        } = this;

        return <div className="apply_keyword_list">
            <TextField
                label=""
                value={searchVal}
                onChange={this.handleSearchValue}
                prefix={<Icon source={SearchMajor} tone="base" />}
                placeholder={t("Search")}
                autoComplete="off"
                clearButton
                onClearButtonClick={() => this.handleSearchValue('')}
            />
            {
                listLoading ? <div className="all_type_product_loading">
                    <Spinner />
                </div> : <div className="all_type_product">
                    <div className="AT_item_main">
                        <div className={`AT_item AT_item_home ${selectedArr["Homepage"].includes(1) ? 'ATactive' : ''}`} onClick={() => this.openSelectType("Homepage")}>
                            <Text variant="headingSm" as="h2">{t("Homepage")}</Text>
                            { (selectedArr["Homepage"].includes(1) ? <span className="check_icon_home">
                                <svg viewBox="0 0 20 20" width={20} height={20} className="Icon_Icon__Dm3QW">
                                    <path fillRule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"></path>
                                </svg>
                            </span> : null) }
                        </div>
                    </div>
                    <div className="at_line"></div>
                    {
                        Object.keys(typeArr).map(item => {
                            return <div className="AT_item_main" key={item} style={{ display: (item === "Homepage" || (item !== "Homepage" && typeArr[item].list.length > 0)) ? 'block' : 'none' }}>
                                <div className={`AT_item ${item === "Homepage" ? 'AT_item_home' : ''} ${selectedArr[item].includes(1) ? 'ATactive' : ''}`} onClick={() => this.openSelectType(item)}>
                                    <Text variant="headingSm" as="h2">{t(item)}</Text>
                                    {item === "Homepage" ? (selectedArr[item].includes(1) ? <span className="check_icon_home">
                                        <svg viewBox="0 0 16 16" width={16} height={16} className="Icon_Icon__Dm3QW">
                                            <path fillRule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"></path>
                                        </svg>
                                    </span> : null) : (!typeSel.includes(item) ? <Icon source={ChevronDownMinor} tone="base" /> : <Icon source={ChevronUpMinor} tone="base" />)}
                                </div>
                                <Collapsible
                                    open={typeSel.includes(item)}
                                >
                                    {
                                        !isNotShowTitle && <div className="top_bar_title">
                                            {
                                                item !== "Other Pages" && <div className="tb_img"></div>
                                            }
                                            <div className="tb_title">{t("Title")}</div>
                                            <div className="tb_keyword">{t("Focus keyword")}</div>
                                        </div>
                                    }
                                    <div className="ai_son_all">
                                        {
                                            item === "Homepage" ? null : typeArr[item].list.map((son, index) => {
                                                return <div className={`ai_son_item ${selectedArr[item].includes(son.id) ? 'aiActive' : ''}`} key={`${son.title}${index}`} onClick={() => this.selectProductItem(item, son)}>
                                                    {
                                                        item !== "Other Pages" ? <Thumbnail
                                                            source={son.imgsrc ? `${son.imgsrc.slice(0, son.imgsrc.lastIndexOf('.'))}_thumb${son.imgsrc.slice(son.imgsrc.lastIndexOf('.'))}` : NoteMajor}
                                                            size="extraSmall"
                                                            alt=""
                                                        /> : null
                                                    }
                                                    <Tooltip content={son.title}>
                                                        <p className="ellipsis_1" style={isNotShowTitle && { 
                                                            width: '20rem',
                                                            maxWidth: '20rem',
                                                            marginRight: '0'
                                                        }}>{son.title}</p>
                                                    </Tooltip>
                                                    <span className="as_keyword ellipsis_1">
                                                        {!isNotShowTitle && son.primary_keywords}
                                                    </span>
                                                    {
                                                        selectedArr[item].includes(son.id) &&
                                                        <span className="check_icon">
                                                            <svg viewBox="0 0 20 20" width={16} height={16} className="Icon_Icon__Dm3QW">
                                                                <path fillRule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"></path>
                                                            </svg>
                                                        </span>
                                                    }
                                                </div>
                                            })
                                        }
                                        {
                                            typeArr[item].list.length < typeArr[item].total ? <div className="view_more_item">
                                                {
                                                    viewMoreLoading.includes(item) ? <Spinner size="small" /> : <div onClick={() => this.ViewMoreItem(item, typeArr[item])}>{t("View more")}</div>
                                                }
                                            </div> : null
                                        }
                                    </div>
                                </Collapsible>
                            </div>
                        })
                    }
                </div >
            }
        </div >;
    }
}

export default AddLinks;
